module.exports = __webpack_public_path__ + "static/media/login.27877b5b.png";